import client from '../client';

export interface OrderToCheck {
  OrderID: number;
  InvoiceNumber: string;
  OrderDate: string;
  CustomerName: string;
  CustomerPO: string;
  ItemCount: number;
  Total: number;
}

export interface OrderCheckDetail {
  OrderID: number;
  InvoiceNumber: string;
  OrderDate: string;
  CustomerName: string;
  CustomerPO: string;
  CustomerIndex: number;
  CustomerID: string;
  BillToName: string;
  BillToAddress1: string;
  BillToAddress2: string;
  BillToCity: string;
  BillToState: string;
  BillToZipCode: string;
  CustomerEmail?: string;
  ShipToName: string;
  ShipToAddress: string;
  ShipToCity: string;
  ShipToState: string;
  ShipToZip: string;
  IsDropShip: boolean;
  ShipVia: string;
  Total: number;
  Freight: number;
  Tax: number;
  Terms: string;
  Note: string | null;
  InSystem: boolean;
  ConfirmedBy: string | null;
  ConfirmedDate: string | null;
  ConfirmationNote: string | null;
  Items: OrderCheckItem[];
}

export interface OrderCheckItem {
  Id: number;
  Ordinal: number;
  LineItemIndex: number;
  PartNumber: string;
  Description: string;
  Quantity: number;
  Price: number;
  Total: number;
}

export interface SendToProductionRequest {
  invoiceNumber: string;
  initials: string;
}

export interface UpdateOrderRequest {
  ShipToName: string;
  ShipToAddress: string;
  ShipToCity: string;
  ShipToState: string;
  ShipToZip: string;
  CustomerPO: string;
  ShipVia: string;
  Freight: number;
  Tax: number;
  Items: {
    Id: number;
    LineItemIndex?: number;
    PartNumber: string;
    Description: string;
    Quantity: number;
    Price: number;
  }[];
}

export const orderCheckingService = {
  /**
   * Get all orders that need to be checked
   */
  getOrdersToCheck: async (): Promise<OrderToCheck[]> => {
    const response: any = await client.get('/order-checking/orders');
    return response.data;
  },

  /**
   * Get order details for checking
   */
  getOrderDetail: async (invoiceNumber: string): Promise<OrderCheckDetail> => {
    const response: any = await client.get(`/order-checking/orders/${invoiceNumber}`);
    return response.data;
  },

  /**
   * Send order to production
   */
  sendToProduction: async (data: SendToProductionRequest): Promise<void> => {
    await client.post('/order-checking/send-to-production', data);
  },

  /**
   * Update order details
   */
  updateOrder: async (invoiceNumber: string, data: UpdateOrderRequest): Promise<void> => {
    await client.put(`/order-checking/orders/${invoiceNumber}`, data);
  },

  /**
   * Search line items for autocomplete
   */
  searchLineItems: async (query: string): Promise<{ Index: number; PartNumber: string; Description: string; Price: number }[]> => {
    const response: any = await client.get('/order-checking/line-items/search', { params: { q: query } });
    return response.data;
  }
};
